import { styled } from '@clickcease/cc-client-components-lib'

export const UserManagementRowStyled = styled('div', {
  color: '$mainTextColor',
  display: 'flex',
  height: '64px',
  borderBottom: '0.5px solid #CACACA',
  justifyContent: 'space-around',
  width: '100%',
  position: 'relative',

  ['&:hover']: {
    background: '$tableHovered',
  },
  variants: {
    notActive: {
      true: {
        color: '$lightNeutral',
      },
    },
  },
})

export const RowPart = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  lineHeight: '64px',
  display: 'flex',
  justifyContent: 'start',
  width: '100%',
  ['&:first-of-type']: {
    paddingLeft: '16px',
  },
})
